import React, { useRef, useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { Modal, Button, Form } from 'react-bootstrap';
import ButtonSpinner from '../../layout/ButtonSpinner';
import { ICON_SAVE, ICON_CANCEL, ICON_SEARCH, ICON_REMOVE } from '../../extras/icons';
import { v4 as uuidv4 } from 'uuid';
import LawyerSearchForm from '../LawyerSearchForm';
import { WaitingMessage } from '../../extras/toastMessages';
import Swal from 'sweetalert2';
import moment from 'moment';
//Función principal
const AccusedFormModal = props => {
    //Tomo los props
    const { show, handleClose, accuseds, setAccuseds, dependencies, minors, defensories, selectedAccused, provincias, localidades } = props;
    //Genero los refs
    const refApellido = useRef();
    //Datos iniciales
    const initialData = {
        index: uuidv4(),
        apellido: '',
        nombre: '',
        tipo_documento: '',
        nro_documento: '',
        domicilio: '',
        email: '',
        telefono: '',
        menor: 0,
        menores: '',
        defensoria: '',
        detenido: 0,
        dependencia: '',
        fecha_detencion: '',
        hora_detencion: '',
        fecha_vencimiento: '',
        hora_vencimiento: '',
        particular: []
    }
    useEffect(() => {
        //Me fijo si es edición
        if(selectedAccused && selectedAccused.index){
            setAccused({
                index: selectedAccused.index,
                apellido: selectedAccused.persona.apellido,
                nombre: selectedAccused.persona.nombre,
                tipo_documento: selectedAccused.persona.tipo_documento,
                nro_documento: selectedAccused.persona.nro_documento,
                domicilio: selectedAccused.domicilio,
                email: selectedAccused.email,
                telefono: selectedAccused.telefono,
                menor: selectedAccused.menor,
                menores: selectedAccused.menores ? selectedAccused.menores.id : '',
                defensoria: selectedAccused.defensoria ? selectedAccused.defensoria.id : '',
                detenido: selectedAccused.detenido,
                dependencia: selectedAccused.dependencia ? selectedAccused.dependencia.id : '',
                fecha_detencion: selectedAccused.fecha_detencion ? moment(selectedAccused.fecha_detencion).format('YYYY-MM-DD') : '',
                hora_detencion: selectedAccused.fecha_detencion ? moment(selectedAccused.fecha_detencion).format('HH:mm:ss') : '',
                fecha_vencimiento: selectedAccused.fecha_vencimiento ? moment(selectedAccused.fecha_vencimiento).format('YYYY-MM-DD') : '',
                hora_vencimiento: selectedAccused.fecha_vencimiento ? moment(selectedAccused.fecha_vencimiento).format('HH:mm:ss') : '',
                particular: selectedAccused.particular
            });
        }else{
            setAccused(initialData);
        }
    }, [selectedAccused]);
    //Inicializo el state local
    const [ accused, setAccused ] = useState(initialData);
    const [ loading, setLoading ] = useState(false);
    const [ showLawyer, setShowLawyer ] = useState(false);
    const [ particulars, setParticulars ] = useState([]);
    const [ hide, setHide ] = useState(false);
    //Manejo de cambios
    const handleChange = e => {
        setAccused({
            ...accused,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Muestro espera
        setLoading(true);
        WaitingMessage('Agregando imputado');
        //Tomo datos
        const defensory = defensories.find(d => d.id === parseInt(values.defensoria));
        const minor = minors.find(m => m.id === parseInt(values.menores));
        const dependency = dependencies.find(dp => dp.id === parseInt(values.dependencia));
        //Armo el objeto de datos
        let data = {
            index: accused.index,
            persona: {
                apellido: values.apellido,
                nombre: values.nombre,
                tipo_documento: values.tipo_documento,
                nro_documento: String(values.nro_documento).replaceAll('.','').replaceAll('-','').replaceAll('/','').replaceAll(' ', '').trim()
            },
            domicilio: values.domicilio,
            email: values.email,
            telefono: values.telefono,
            menor: values.menor,
            defensoria:  defensory ? {
                id: values.defensoria,
                descripcion: defensory.descripcion
            } : null,
            menores: minor ? {
                id: values.menores,
                descripcion: minor.descripcion
            } : null,
            detenido: values.detenido,
            dependencia: dependency ? {
                id: values.dependencia,
                descripcion: dependency.descripcion
            } : null,
            fecha_detencion: values.fecha_detencion ? `${values.fecha_detencion} ${values.hora_detencion}:00` : null,
            fecha_vencimiento: values.fecha_vencimiento ? `${values.fecha_vencimiento} ${values.hora_vencimiento}:00` : null,
            particular: particulars
        }
        //Me fijo si es edición
        if(selectedAccused){
            //Lo agrego a los acusados
            setAccuseds(accuseds.map( accused =>
                accused.index === data.index ? accused = data : accused
            ));
        }else{
            //Lo agrego a los acusados
            setAccuseds([
                ...accuseds,
                data
            ]);
        }
        //Cierro la ventana
        handleCloseForm();
        //Cierro espera
        Swal.close();
        setLoading(false);
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Limpio los particulares
        setParticulars([]);
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAccused(initialData);
        //Cierro
        handleClose();
    }
    //Eliminar abogado particular
    const handleRemoveLawyer = selected => {
        //Seteo sin el abogado eliminado
        setParticulars(
            particulars.filter( p => p.index !== selected.index )
        );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        tipo_documento: yup.string().required(),
        nro_documento: yup.number().required(),
        domicilio: yup.string().required(),
        menor: yup.number().required(),
        detenido: yup.number().required(),
        telefono: yup.string().nullable(),
        email: yup.string().email().when('telefono', {
            is: (telefono) => !telefono || telefono.length === 0,
            then: yup.string().email().required(),
            otherwise: yup.string().email().nullable()
        })
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="xl"
        >
            {
                hide ? (
                    <div className="custom-backdrop-modal"></div>
                ) : null
            }
            <Modal.Header closeButton>
                <Modal.Title>
                    Imputado&nbsp;
                    <small><strong>{ selectedAccused ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...accused }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        El <strong>Tipo y Nº de documento</strong> son obligatorios. Si no conoce el número ingrese 0 (cero) en el campo correspondiente.
                                        <br/>
                                        En relación al nro. de teléfono y el email, sólo es obligatorio uno de los dos campos.
                                    </div>
                                </div>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        placeholder="Apellido"
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        ref={refApellido}
                                        isInvalid={!!errors.apellido}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        placeholder="Nombre"
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        as="select"
                                        id="tipo_documento"
                                        className="form-control"  
                                        name="tipo_documento" 
                                        type="text" 
                                        value={ values.tipo_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo_documento}
                                        disabled={ loading }
                                    >
                                        <option value="">Tipo documento</option>
                                        <option value="DNI">DNI</option>
                                        <option value="CUIT">CUIT/CUIL</option>
                                        <option value="PASAPORTE">PASAPORTE</option>
                                        <option value="MATRICULA">MATRICULA</option>
                                        <option value="LC">L.C.</option>
                                        <option value="LE">L.E.</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        id="nro_documento"
                                        className="form-control" 
                                        name="nro_documento" 
                                        type="text" 
                                        placeholder="Nro. Documento"
                                        value={ values.nro_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nro_documento}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nro_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="domicilio"
                                        className="form-control" 
                                        name="domicilio" 
                                        type="text" 
                                        placeholder="Domicilio"
                                        value={ values.domicilio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.domicilio}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.domicilio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        placeholder="Teléfono"
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        placeholder="Email"
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>                                                             
                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                        Seleccione si el IMPUTADO es <strong>MENOR</strong> o no. En caso de que lo sea podrá seleccionar la <strong>DEFENSORÍA DE MENORES</strong> que participa.
                                    </div>
                                </div>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        as="select"
                                        id="menor"
                                        className="form-control"  
                                        name="menor"  
                                        value={ values.menor }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menor}
                                        disabled={ loading }
                                    >
                                        <option value="0">NO</option>
                                        <option value="1">SI</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menor }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as="select"
                                        id="menores"
                                        className="form-control"  
                                        name="menores"  
                                        value={ values.menor == '0' ? '' : values.menores }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menores}
                                        disabled={ loading || values.menor == '0' }
                                    >
                                        <option value="">Seleccione Defensoría de Menores</option>
                                        {
                                            minors ? (
                                                minors.map(minor => (
                                                    <option value={minor.id} key={`afm${minor.id}`}>
                                                        { minor.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menores }
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                        A cotinuación podrá seleccionar la <strong>DEFENSA TÉCNICA</strong> del IMPUTADO. Seleccione si actúa algún equipo operativo del MPD y/o el/los abogado/s correspondientes.
                                    </div>
                                </div>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as="select"
                                        id="defensoria"
                                        className="form-control"  
                                        name="defensoria"  
                                        value={ values.defensoria }
                                        onChange={handleChange}
                                        isInvalid={!!errors.defensoria}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione el Equipo del MPD</option>
                                        {
                                            defensories ? (
                                                defensories.map(defensory => (
                                                    <option value={defensory.id} key={`afd${defensory.id}`}>
                                                        { defensory.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.defensoria }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="col-md-6 form-group">
                                    <Button variant="primary" className="float-right" onClick={() => setShowLawyer(true)}>
                                        <ICON_SEARCH /> BUSCAR ABOGADO PARTICULAR
                                    </Button>

                                    <LawyerSearchForm
                                        show={showLawyer}
                                        handleClose={() => {setShowLawyer(false);setHide(false)}}
                                        particulars={particulars}
                                        setParticulars={setParticulars}
                                        hideModal={setHide}
                                    />
                                </div>
                                <div className="col-12">
                                    {
                                        particulars && particulars.length > 0 ? (
                                            <table className="table table-sm">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th colSpan="4">Abogados particulares</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        particulars.map(particular => (
                                                            <tr key={`afafp${particular.id}`}>
                                                                <td className="align-middle">
                                                                    { particular.persona.apellido + ', ' + particular.persona.nombre }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.email }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.telefono }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    <Button variant="danger" size="sm" onClick={() => handleRemoveLawyer(particular)}>
                                                                        <ICON_REMOVE />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        ) : null
                                    }
                                </div>
                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                        En el siguiente ítem deberá indicar si el IMPUTADO se encuentra <strong>DETENIDO</strong>, en caso afirmativo deberá completar toda la información relacionada.
                                    </div>
                                </div>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        as="select"
                                        id="detenido"
                                        className="form-control"  
                                        name="detenido"  
                                        value={ values.detenido }
                                        onChange={handleChange}
                                        isInvalid={!!errors.detenido}
                                        disabled={ loading }
                                    >
                                        <option value="">Privado libertad?</option>
                                        <option value="0">NO</option>
                                        <option value="1">SI</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.detenido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-10">
                                    <Form.Control
                                        as="select"
                                        id="dependencia"
                                        className="form-control"  
                                        name="dependencia"  
                                        value={ values.dependencia }
                                        onChange={handleChange}
                                        isInvalid={!!errors.dependencia}
                                        disabled={ loading || values.detenido !== '1' }
                                    >
                                        <option value="">Lugar detención/aprehensión</option>
                                        {
                                            dependencies ? (
                                                dependencies.map(dependency => (
                                                    <option value={ dependency.id} key={`afmd${dependency.id}`}>
                                                        { dependency.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.dependencia }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Fecha Det.</Form.Label>
                                    <Form.Control
                                        id="fecha_detencion"
                                        className="form-control" 
                                        name="fecha_detencion" 
                                        type="date" 
                                        placeholder="Fecha privación libertad"
                                        value={ values.fecha_detencion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fecha_detencion}
                                        disabled={ loading || values.detenido !== '1' }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha_detencion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Hora Det.</Form.Label>
                                    <Form.Control
                                        id="hora_detencion"
                                        className="form-control" 
                                        name="hora_detencion" 
                                        type="time" 
                                        placeholder="Hora privación libertad"
                                        value={ values.hora_detencion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.hora_detencion}
                                        disabled={ loading || values.detenido !== '1' }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.hora_detencion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Fecha Vto.</Form.Label>
                                    <Form.Control
                                        id="fecha_vencimiento"
                                        className="form-control" 
                                        name="fecha_vencimiento" 
                                        type="date" 
                                        placeholder="Fecha vencimiento privación libertad"
                                        value={ values.fecha_vencimiento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fecha_vencimiento}
                                        disabled={ loading || values.detenido !== '1' }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha_detencion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Hora Vto.</Form.Label>
                                    <Form.Control
                                        id="hora_vencimiento"
                                        className="form-control" 
                                        name="hora_vencimiento" 
                                        type="time" 
                                        placeholder="Hora vencimiento privación libertad"
                                        value={ values.hora_vencimiento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.hora_vencimiento}
                                        disabled={ loading || values.detenido !== '1' }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.hora_vencimiento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>{selectedAccused ? 'ACTUALIZAR' : 'AGREGAR'}</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AccusedFormModal;